import router from './../../router/index.js';

export var routing = {
  methods: {
    goToRoute(path) {
      router.push(path);
    },
    goToRoot() {
      this.goToRoute('/');
    },
    goToLogin(applicationName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/login');
      } else {
        this.goToRoute('/login/' + applicationName);
      }
    },
    goToRegister(applicationName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/register');
      } else {
        this.goToRoute('/register/' + applicationName);
      }
    },
    goToResetPassword(applicationName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/reset-password');
      } else {
        this.goToRoute('/reset-password/' + applicationName);
      }
    },
    goToChangePassword(applicationName, userName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/change-password/' + userName);
      } else {
        this.goToRoute('/change-password/' + applicationName + '/' + userName);
      }
    },
    goToConfirm(applicationName, userName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/confirm/' + userName);
      } else {
        this.goToRoute('/confirm/' + applicationName + '/' + userName);
      }
    },
    goToMain(applicationName) {
      if (this.emptyString(applicationName)) {
        this.goToRoute('/main');
      } else {
        this.goToRoute('/main/' + applicationName);
      }
    },
    goToErrorPage({ code, message, redirect }) {
      router.push({ path: `/error/${code}`, query: { message, redirect } });
    },
    goToSuccess({ message, redirect }) {
      this.goToErrorPage({ code: '200', message, redirect })
    },
    goToErrorUnauthorized({ message, redirect }) {
      this.goToErrorPage({ code: '401', message, redirect })
    },
    goToErrorForbidden({ message, redirect }) {
      this.goToErrorPage({ code: '403', message, redirect })
    },
    goToErrorNotFound({ message, redirect }) {
      this.goToErrorPage({ code: '404', message, redirect })
    },
    goToErrorInternalServer({ message, redirect }) {
      this.goToErrorPage({ code: '500', message, redirect });
    },
    goToErrorServiceUnavaliable({ message, redirect }) {
      this.goToErrorPage({ code: '503', message, redirect });
    },
    goToApplication(applicationName) {
      this.goToRoute('/application/' + applicationName);
    },
    goToExternalUrl(url) {
      window.location.href = url;
    }
  }
}